<template>
  <v-container class="pb-0 px-1">
      <v-form ref="recursosFilterForm">
          <v-row>
          <!-- <v-spacer></v-spacer> -->
          <v-col class="py-0 px-2" cols="2" v-if="temPermissaoCarteira">
            <label>Carteira</label>
            <v-select
                v-model="formData.carteira_id"
                :items="carteirasFilter"
                item-value="id"
                item-text="nome"
                :menu-props="{ bottom: true, offsetY: true }"
                flat
                solo
                dense
                outlined
                @change="changeCarteira"
            ></v-select>
          </v-col>
          <v-col class="py-0 px-2" cols="2" sm="6" md="2">
          <label>Tipo de data</label>
          <v-select
            v-model="formData.tipo_data"
            :items="[
              { id: 'data_pagamento', descricao: 'Pagamento' },
              { id: 'data_prazo_recebimento', descricao: 'Vencimento do recurso' }
            ]"
            item-value="id"
            item-text="descricao"
            :menu-props="{ bottom: true, offsetY: true }"
            flat
            solo
            dense
            outlined
          ></v-select>
        </v-col>
          <v-col class="py-0 px-2" cols="2">
            <label>Data de</label>
            <v-menu
                ref="dtI"
                v-model="dtI"
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
                >
                <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="dateIFormatted"
                    dense
                    v-mask="'##/##/####'"
                    format="DD/MM/YYYY"
                    placeholder="DD/MM/YYYY"
                    label
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    append-icon="mdi-calendar-blank"
                    @blur="dateI = parseDate(dateIFormatted)"
                    :rules="[formRules.typeDateFormated]"
                ></v-text-field>
                </template>
                <v-date-picker color="primary"  v-model="dateI" no-title scrollable></v-date-picker>
            </v-menu>
          </v-col>
          <v-col class="py-0 px-2" cols="2">
            <label>até</label>
            <v-menu
                ref="dtF"
                v-model="dtF"
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
            >
                <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="dateFFormatted"
                    v-mask="'##/##/####'"
                    format="DD/MM/YYYY"
                    placeholder="DD/MM/YYYY"
                    label
                    dense
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    append-icon="mdi-calendar-blank"
                    @blur="dateF = parseDate(dateFFormatted)"
                    :rules="[formRules.typeDateFormated]"
                ></v-text-field>
                </template>
                <v-date-picker color="primary"  v-model="dateF" no-title scrollable></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="6" md="3" class="px-3 py-0">
            <label>Prestador</label>
            <v-autocomplete
              v-model="formData.prestador_id"
              :items="prestadoresFilter"
              item-value="id"
              item-text="prest_nome"
              label="Selecione"
              multiple
              chips
              outlined
              flat
              solo
              dense
              filled
              :disabled="formData.carteira_id!=null || prestadoresFilter.length==1"
              :search-input.sync="searchInput" 
            >
          <template v-slot:item="data">
            <v-list-item @click="toggleAutocomplete(data.item, 'prestador_id');" :class="formData.prestador_id.includes(data.item.id)? 'primary--text v-list-item--active': ''">
              <v-list-item-content>
                <v-list-item-title>{{data.item.prest_nome}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
        </template>
          <template v-slot:selection="data">
            <v-chip v-if="data.index < 2" small label class="ma-1" :style="formData.prestador_id.length>1? 'max-width:28%':'max-width:90%'">{{
              data.item.prest_nome
            }}</v-chip>
            <span v-if="data.index == 2" class="ml-2 grey--text caption">
              (+{{
                formData.prestador_id.length == 3
                  ? formData.prestador_id.length - 2 + " outro"
                  : formData.prestador_id.length - 2 + " outros"
              }})
            </span>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="12" sm="6" md="3" class="px-3 py-0">
            <label>Operadoras</label>
            <v-autocomplete
              v-model="formData.operadora_ans_id"
              :items="operadorasFilter"
              item-value="id"
              item-text="oper_nome"
              label="Selecione"
              multiple
              chips
              outlined
              flat
              solo
              dense
              filled
              :disabled="formData.carteira_id!=null || operadorasFilter.length==1"
              :search-input.sync="searchInput" 
            >
          <template v-slot:item="data">
            <v-list-item @click="toggleAutocomplete(data.item, 'operadora_ans_id'); getResponsaveis()" :class="formData.operadora_ans_id.includes(data.item.id)? 'primary--text v-list-item--active': ''">
              <v-list-item-content>
                <v-list-item-title>{{data.item.oper_nome}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
        </template>
          <template v-slot:selection="data">
            <v-chip v-if="data.index < 2" small label class="ma-1" :style="formData.operadora_ans_id.length>1? 'max-width:28%':'max-width:90%'">{{
              data.item.oper_nome
            }}</v-chip>
            <span v-if="data.index == 2" class="ml-2 grey--text caption">
              (+{{
                formData.operadora_ans_id.length == 3
                  ? formData.operadora_ans_id.length - 2 + " outro"
                  : formData.operadora_ans_id.length - 2 + " outros"
              }})
            </span>
          </template>
        </v-autocomplete>
      </v-col>
      <!-- <v-col class="py-0 px-2" cols="2" v-if="grupoEconomico==167 && userData.UsuarioTradimus">
          <v-switch
            v-model="formData.pendencia"
            label="Com pendência"
            color="primary"
            class="mr-0"
            ></v-switch>
      </v-col> -->
      <v-col class="py-0 px-2" cols="2" v-if="grupoEconomico==167 && userData.UsuarioTradimus">
            <label>Pendencia</label>
            <v-select
                v-model="formData.pendencia_recurso_tipo_id"
                :menu-props="{ bottom: true, offsetY: true }"
                solo
                flat
                dense
                :items="motivosList"
                item-text="descricao"
                item-value="id"
                outlined
            ></v-select>
          </v-col>
          <v-col class="py-0 px-2" cols="2">
            <label>Criticidade</label>
            <v-select
            v-model="formData.criticidade"
            :items="criticidadeFilter"
            item-value="id"
            item-text="descricao"
            :menu-props="{ bottom: true, offsetY: true }"
            flat
            solo
            dense
            outlined
          >
            <template v-slot:item="data">
              <template v-if="(typeof data.item !== 'object')">
                <v-list-item-content v-text="data.item"></v-list-item-content>
              </template>
              <template v-else>
                <v-list-item-content :style="'color:'+ data.item.cor">
                  <v-list-item-title v-html="data.item.descricao"></v-list-item-title>
                </v-list-item-content>
              </template>
            </template>
          </v-select>
          </v-col>
            
          <!-- <v-col class="py-0 px-2" cols="2">
            <label>Operadora</label>
            <v-select
                v-model="formData.operadora_ans_id"
                :items="operadorasFilter"
                item-value="id"
                item-text="oper_nome"
                :menu-props="{ bottom: true, offsetY: true }"
                flat
                solo
                dense
                outlined
            ></v-select>
          </v-col> -->
           <v-col class="py-0 px-2" cols="2">
            <label>Responsável</label>
            <v-select
                v-model="formData.owner_id"
                :items="responsaveisFilter"
                item-value="Id"
                item-text="UserName"
                :menu-props="{ bottom: true, offsetY: true }"
                flat
                solo
                dense
                outlined
            ></v-select>
          </v-col>
          <v-col class="py-0 px-2" cols="2">
           <label>Status</label>
          <v-select
            v-model="formData.etapa"
            :items="statusFilter"
            item-value="id"
            item-text="descricao"
            :menu-props="{ bottom: true, offsetY: true }"
            flat
            solo
            dense
            outlined
          >
            <template v-slot:item="data">
              <template v-if="(typeof data.item !== 'object')">
                <v-list-item-content v-text="data.item"></v-list-item-content>
              </template>
              <template v-else>
                <v-list-item-content>
                  <v-list-item-title v-html="data.item.descricao"></v-list-item-title>
                </v-list-item-content>
                <v-list-item-avatar size="15" :color="data.item.cor" v-if="data.item.cor">
                </v-list-item-avatar>
              </template>
            </template>
          </v-select>
          </v-col>
          <!-- Data do evento de conclusão -->
          <v-col class="py-0 px-2" cols="2" v-if="formData.etapa == '99'">
            <label>Data da conclusão entre</label>
            <v-menu
                ref="dtEventoI"
                v-model="dtEventoI"
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
                >
                <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="dateEventoIFormatted"
                    dense
                    v-mask="'##/##/####'"
                    format="DD/MM/YYYY"
                    placeholder="DD/MM/YYYY"
                    label
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    append-icon="mdi-calendar-blank"
                    @blur="dateEventoI = parseDate(dateEventoIFormatted)"
                    :rules="[formRules.typeDateFormated]"
                ></v-text-field>
                </template>
                <v-date-picker color="primary"  v-model="dateEventoI" no-title scrollable></v-date-picker>
            </v-menu>
          </v-col>
          <v-col class="py-0 px-2" cols="2" v-show="formData.etapa == 99">
            <label>até</label>
            <v-menu
                ref="dtEventoF"
                v-model="dtEventoF"
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
            >
                <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="dateEventoFFormatted"
                    v-mask="'##/##/####'"
                    format="DD/MM/YYYY"
                    placeholder="DD/MM/YYYY"
                    label
                    dense
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    append-icon="mdi-calendar-blank"
                    @blur="dateEventoF = parseDate(dateEventoFFormatted)"
                    :rules="[formRules.typeDateFormated]"
                ></v-text-field>
                </template>
                <v-date-picker color="primary"  v-model="dateEventoF" no-title scrollable></v-date-picker>
            </v-menu>
          </v-col>
          <v-col class="pt-0 pb-2 px-2" cols="2">
            <label>Pesquisar por</label>
            <v-select
                v-model="typeSearch"
                :items="typeSearchList"
                item-value="id"
                item-text="descricao"
                :menu-props="{ bottom: true, offsetY: true }"
                flat
                solo
                dense
                outlined
                @change="formData.protocolo_recursado = null; formData.protocolo_envio = null; formData.num_lote = null; search = null"
            ></v-select>
          </v-col>
          <v-col class="pt-5 pb-2 px-2" cols="2">
            <!-- <label>Nota Fiscal</label> -->
            <v-text-field
                v-model="search"
                prepend-inner-icon="mdi-magnify"
                :placeholder="typeSearch == 1 ?'Protocolo Recursado' :typeSearch == 2 ?'Número do lote' :typeSearch == 3 ?'Protocolo de envio' :null"
                single-line
                outlined
                dense
                hide-details
                :disabled="typeSearch == null"
                @input="typeSearch == 1 ? formData.protocolo_recursado = search :typeSearch == 2 ?formData.num_lote = search : typeSearch == 3 ?formData.protocolo_envio = search :null"
            ></v-text-field>
          </v-col>
          <v-col class="pt-5 px-2" >
          </v-col>
          <v-col class="pt-5 px-2" cols="2">
              <v-spacer></v-spacer>
              <v-btn
                small 
                height="32px"
                color="primary"
                class="px-1 mr-3"
                depressed
                @click="sendFilter()"
                >Filtrar</v-btn>
              <v-btn
                outlined
                small 
                height="32px"
                color="primary"
                class="px-1 ml-1"
                depressed
                @click="clearFilters()"
                >Limpar Filtro</v-btn>
          </v-col>
      </v-row>
      </v-form>
  </v-container>
</template>

<script>
import { mapState } from "vuex"
export default {
    data() {
        return{
            formData: {
                carteira_id: null,
                criticidade: null,
                prestador_id: [],
                operadora_ans_id: [],
                owner_id: null,
                etapa: null,
                data_ate: null,
                data_entre: null,
                pendencia_recurso_tipo_id: null,
                protocolo_envio: null,
                protocolo_recursado: null,
                num_lote: null,
                data_evento_inicio: null,
                data_evento_fim: null,
                tipo_data: "data_pagamento"
            },
            dtI: false,
            dtEventoI: false,
            dateI:null,
            dateEventoI: null,
            dateIFormatted: null,
            dateEventoIFormatted: null,
            dtF: false,
            dtEventoF: false,
            dateF: null,
            dateEventoF: null,
            dateFFormatted: null,
            dateEventoFFormatted: null,
            criticidadeFilter: [{id: null, descricao: "Selecione"}, {id: 'acima', descricao: "Acima do prazo", cor:'#D0021B'}, {id: 'critico', descricao: "Com prazo critico", cor:'#FC9E0D'}, {id: 'noprazo', descricao: "Dentro do prazo", cor:'#999999'}],
            motivosList: [],
            operadorasFilter: [],
            prestadoresFilter: [],
            responsaveisFilter:[],
            carteirasFilter: [],
            statusFilter: [],
            logins: [{
                id: null,
                descricao: 'Selecione',
                color: null,
            },{
                id: "d3",
                descricao: "Login012",
                color: "#32B88B",
            },{
                id: "d5",
                descricao: "Login023",
                color: "#B2B842",
            },{
                id: "d>5",
                descricao: "1234456",
                color: "#4A4A4A",
            }],
            searchInput: null,
            typeSearchList: [
              { id: null, descricao: "Selecione"},
              { id: 1, descricao: "Protocolo recursado"},
              { id: 2, descricao: "Número de lote"},
              { id: 3, descricao: "Protocolo de envio"}
            ],
            typeSearch: null,
            search: null,
        }
    },
    computed: {
        ...mapState({
            formRules: state => state.formRules,
            grupoEconomico: (state) => state.permissions.grupoEconomico,
            userData: (state) => state.userData.userData
        }),
    },  
    watch: {
        prestadores:{
            deep: true,
            handler(val){
                this.updateListaFilter(val, 'prestadoresFilter', 'prestador_id', {id: null, prest_nome: "Selecione"}, true)
            }
        },
        operadoras:{
            deep: true,
            handler(val){
                this.updateListaFilter(val, 'operadorasFilter', 'operadora_ans_id', {id: null, oper_nome: "Selecione"}, true)
            }
        },
        statusList:{
            deep: true,
            handler(val){
                this.updateListaFilter(val, 'statusFilter', 'etapa', {id: null, descricao: "Selecione"}, false)
            }
        },
        responsaveis:{
            deep: true,
            handler(val){
                this.updateListaFilter(val, 'responsaveisFilter', 'owner_id', {Id: null, UserName: "Selecione"}, false)
            }
        },
        carteiras:{
            deep: true,
             handler(val){
                this.updateListaFilter(val, 'carteirasFilter', 'carteira_id', {id: null, nome: "Selecione"}, false)
            }
        },
        dateF(val){
          if (!val) {
            this.dateFFormatted = null
          } else {
            if (!!this.dateI && Date.parse(this.dateI) > Date.parse(val)){
              this.dateI = val
            }
            this.dateFFormatted = this.formatDate(val)
          }
        },
        dateEventoF(val){
          if (!val) {
            this.dateEventoFFormatted = null
          } else {
            if (!!this.dateEventoI && Date.parse(this.dateEventoI) > Date.parse(val)){
              this.dateEventoI = val
            }
            this.dateEventoFFormatted = this.formatDate(val)
          }
        },
        dateFFormatted(val){
          this.formData.data_ate = this.parseDate(val)
        },
        dateEventoFFormatted(val){
          this.formData.data_evento_fim = this.parseDate(val)
        },
        dateI(val){
          if (!val) {
            this.dateIFormatted = null
          } else {
            if (!!this.dateF && Date.parse(this.dateF) < Date.parse(val)){
              this.dateF = val
            }
            this.dateIFormatted = this.formatDate(val)
          }
        },
        dateEventoI(val){
          if (!val) {
            this.dateEventoIFormatted = null
          } else {
            if (!!this.dateEventoF && Date.parse(this.dateF) < Date.parse(val)){
              this.dateEventoF = val
            }
            this.dateEventoIFormatted = this.formatDate(val)
          }
        },
        dateIFormatted(val){
          this.formData.data_entre = this.parseDate(val)
        },
        dateEventoIFormatted(val){
          this.formData.data_evento_inicio = this.parseDate(val)
        },
    },
    beforeMount() {
      let obj = {
          query: [
            {
              modulo: "Recebiveis",
              acao: "GetMotivosPendenciaRecurso",
              payload: {
                grupo_economico: this.grupoEconomico,
              },
            },
          ],
        };
        this.$store
          .dispatch("request/doRequest", obj, { root: true })
          .then((response) => {
          if (!response || response.isAxiosError || response.erros.length) {
            this.$store.commit("hideLoader");
            return;
          }
          this.motivosList = response.dados;
          this.motivosList.unshift({id: 0, descricao: "Todos"})
          this.motivosList.unshift({id: null, descricao: "Selecione"})
        })
        
        this.updateListaFilter(this.prestadores, 'prestadoresFilter', 'prestador_id', {id: null, prest_nome: "Selecione"}, true)
        this.updateListaFilter(this.operadoras, 'operadorasFilter', 'operadora_ans_id', {id: null, oper_nome: "Selecione"}, true)
        this.updateListaFilter(this.responsaveis, 'responsaveisFilter', 'owner_id', {Id: null, UserName: "Selecione"},false)
        this.updateListaFilter(this.statusList, 'statusFilter', 'etapa', {id: null, descricao: "Selecione"}, false)
        this.updateListaFilter(this.carteiras, 'carteirasFilter', 'carteira_id', {id: null, nome: "Selecione"}, false)
    },
    mounted() {
        let filtroExterno = null
        this.$store.dispatch("recebiveis/getFilter",'recursosGlosaFilter',  { root: true }).then(resp => { 
            filtroExterno = resp
            if(filtroExterno){
                this.formData = Object.assign(this.formData,{...filtroExterno})
                this.dateIFormatted = this.formatDate(this.formData.data_entre)
                this.dateFFormatted = this.formatDate(this.formData.data_ate)
            } 
            this.filterList(this.formData)
        })
    },
    methods: {
        clearFilters(){
            this.search = null
            this.formData.etapa = null
            this.formData.carteira_id = null
            this.formData.data_entre = null
            this.formData.data_ate = null
            this.formData.owner_id= null
            this.dateIFormatted = null
            this.dateFFormatted = null
            this.formData.num_lote = null
            this.formData.protocolo_envio = null
            this.formData.protocolo_recursado = null
            this.formData.pendencia_recurso_tipo_id = null
            this.formData.tipo_data = "data_pagamento"
            this.dateI = null
            this.dateF = null
            if (this.prestadoresFilter.length>1) 
            this.formData.prestador_id = []
            this.formData.operadora_ans_id = []
            this.changePrestador()
            this.$nextTick(()=>this.filterList(this.formData))
        },
        changeCarteira() {
          this.formData.operadora_ans_id = this.operadorasFilter.length==1? [this.operadorasFilter[0].id] : []
          this.formData.prestador_id = this.prestadoresFilter.length==1? [this.prestadoresFilter[0].id] : []
        },
        changePrestador(){
          let opts = {
              grupoEconomico: this.formData.grupo_economico,
              modulo_operadora: "recebiveis",
              prestador_ids: this.formData.prestador_id
            }
           this.$store.dispatch("permissions/getOperadoras", opts)
          .then(()=> this.getResponsaveis())
        },
        getResponsaveis(){
          let opts = {
              grupoEconomico: this.formData.grupo_economico,
              modulo_operadora: "recebiveis",
              prestador_ids: this.formData.prestador_id,
              operadora_ans_ids: this.formData.operadora_ans_id
            }
          this.$store.dispatch("recebiveis/getResponsaveis", opts)
        },
        sendFilter(){
          if(this.$refs.recursosFilterForm.validate()){
            if(!this.formData.data_ate && this.formData.data_entre) {
                this.dateF = this.formData.data_entre
                this.formData.data_ate = this.formData.data_entre
            }
            this.$nextTick(()=>this.filterList(this.formData))
          }
        },
        toggleAutocomplete(item, campo) {
          this.searchInput=null
          let index = this.formData[campo].indexOf(item.id)
          //  index > -1  está excluindo a operadora
          if (index > -1) {
            this.formData[campo].splice(index, 1)
          } else {
            //  index < 0  está adicionando a operadora
              this.formData[campo].push(item.id)
          }
          this.$nextTick(()=> {if(campo=='prestador_id') this.changePrestador()})
            return
        },
        updateListaFilter(lista, nomedaLista, nomedocampo, objSelecione, verificaLength ){
        this[nomedaLista] = Array.from(lista)
        let param = nomedaLista == 'responsaveisFilter'? 'Id': 'id'
            if(lista.length==1 && verificaLength){
                if(nomedaLista != "prestadoresFilter" &&  nomedaLista != "operadorasFilter" ){
                    this.formData[nomedocampo] = lista[0][param] 
                }
                else {
                    this.formData[nomedocampo] = []
                    this.formData[nomedocampo].push(lista[0][param])
                }
            } else {
                if(nomedaLista != "prestadoresFilter" &&  nomedaLista != "operadorasFilter" ){
                    this[nomedaLista].unshift(objSelecione)
                }
                if(nomedaLista != "prestadoresFilter" &&  nomedaLista != "operadorasFilter" ){
                    let ind = lista.findIndex(el=> el[param] == this.formData[nomedocampo] )
                    this.formData[nomedocampo] = ind > -1? lista[ind][param]  : null
                }
                else {
                    this.formData[nomedocampo] = (this.formData[nomedocampo] && this.formData[nomedocampo].length)? this.formData[nomedocampo].filter(el => this[nomedaLista].findIndex(item=> item.id == el)>-1 ) : []
                }
            }
        }
    },
    props: {
        prestadores: Array,
        operadoras: Array,
        filterList: Function,
        formatDate: Function,
        parseDate: Function,
        responsaveis: Array,
        statusList: Array,
        carteiras: Array,
        temPermissaoCarteira: Boolean,
    }
}
</script>

<style>
</style>